import Flickity from 'flickity';
import Component from '~/components/component';
import {PageEvent} from '~/pages/page';
import VideoTmp from '../video-tmp/video-tmp';
import States from '../../helpers/states'
import noUiSlider from 'nouislider';

export default class HistorySlider extends Component {
	constructor(...args) {
		super(...args);

		this._isBlocked = false;
		this._current = 0;
		this._firstStep = true;

		this.getDom();
		this.initSlider();
		this.initNoUiSlider();
		// this.initCursor();
	}
	
	getDom() {
		this.dom.slider = this.dom.component.querySelector('.carousel');
		this.dom.slide = this.dom.component.querySelectorAll('.carousel-cell');
		this._slideLength = this.dom.slide.length;

		this.dom.previous = this.dom.component.querySelector('.js-previous');
		this.dom.next = this.dom.component.querySelector('.js-next');

		this.dom.anim = this.dom.component.querySelectorAll('.js-anim');
		this.dom.about = this.dom.component.querySelector('.js-about');
		this.dom.year = this.dom.about.querySelector('.js-year');
		this.dom.title = this.dom.about.querySelector('.js-title');
		this.dom.description = this.dom.about.querySelector('.js-description');

		// this.dom.scroller = this.dom.component.querySelector('.js-scroller');
		// this.dom.cursor = this.dom.scroller.querySelector('.js-cursor');

		// SCROLL noUiSlider
		this.dom.scrollContainer = this.dom.component.querySelector('.js-container-scroller-nouislider');
		this.dom.scroll = this.dom.scrollContainer.querySelector('.js-scroller-nouislider');
	}



	initSlider() {
		// Prepare
		this._Flkty = new Flickity( this.dom.slider, {
			wrapAround: false,
			prevNextButtons: false,
			pageDots: false
		});
		this.updateArrow();

		// Events
		this._Flkty.on( 'change', (index) => {
			this._current = index;
			this.updateArrow();
			this.updateSlide();
			// this.moveCursor();
			this.updateCursor( this._current );
		});

		// Prevent ScrollingY while Dragging slider items for IOS Devices
		this._Flkty.on('dragStart', (e) => {
			document.ontouchmove = e => e.preventDefault()
		});
		this._Flkty.on('dragEnd', (e) => {
			document.ontouchmove = () => true;
		});

		this._Flkty.on('staticClick', (e) => {
			let target = e.target
			if(!target.classList.contains('js-call-video')){ // On mobile e.target is not .js-call-video
				let jsCallVideoParent = closest(target, '.js-call-video')
				if(!jsCallVideoParent) return;
				target = jsCallVideoParent
			}
			this.emit(PageEvent.FLICKITY_CLICK, target)
		})	

		this.dom.previous.addEventListener('click', () => {
			if (this._isBlocked == true)
				return;
			
			this._isBlocked = true;
			this.updateDraggable(false);
			this._Flkty.previous();
		});
		this.dom.next.addEventListener('click', ()=>{
			if (this._isBlocked == true)
				return;
			
			this._isBlocked = true;
			this.updateDraggable(false);
			this._Flkty.next();
		});
	}

	initNoUiSlider() {
		// this._rangeDate = [];
		// for( let i = 0, j = this._slideLength; i < j; i++ ) {
		// 	let slide = this.dom.slide[i];
		// 	this._rangeDate.push( parseInt(slide.dataset.year) );
		// }

		this._noUiSlider = noUiSlider.create( this.dom.scroll, {
			start: 0,
			step: 1,
			range: {
				'min': 0,
				'max': this._slideLength - 1
			}
		});

		this.dom.scrollCursor = this.dom.component.querySelector('.noUi-origin');
		this.dom.scrollCursor.style.width = 100 / this._slideLength + '%';
		this._currentTranslate = ( this._slideLength - 1 ) * -100;
		this.dom.scrollCursor.style.transform = "translate(" + this._currentTranslate + "%, 0px )";

		this._noUiSlider.on('update', (values, handle) => {

			this.dom.scrollCursor.style.transform = "translate(" + this._currentTranslate + "%, 0px" + " )"; // To debug the first move

			let indexRange = parseInt(values[handle]);
			if( indexRange != -1 ) {
				this._Flkty.select( indexRange )
			}
		});

	}

	initCursor() {
		this.dom.cursor.style.width = this.dom.scroller.offsetWidth / this.dom.slide.length + 'px';
	}

	moveCursor() {
		TweenLite.to(this.dom.cursor, 0.7, {
			x: this._current * this.dom.cursor.offsetWidth,
			ease: Power2.easeInOut
		});
	}

	updateCursor( index ) {
		this._noUiSlider.set([index, null]);

		let translate = -100 * (this._slideLength - 1 - this._current);
		this.dom.scrollCursor.style.transform = "translate(" + translate + "%, 0px )";
	}

	updateSlide() {

		for(var componentName in States.Components){
            var component = States.Components[componentName];

            // Bind Global VideoTmp Events
            if( component.length > 0 ) {
                for( let i = 0, j = component.length; i < j; i++) {
                    let componentTab = component[i];
                    if(componentTab instanceof VideoTmp){
                        componentTab.pause()
                    }
                }
            } else {
                if(component instanceof VideoTmp){
                    component.pause()                     
                }
            }
        }

		this.updateDraggable(false);
		this.tl = new TimelineMax({
			onComplete: () => {
				this._isBlocked = false;
				this.updateDraggable(true);
			}
		});

		let slide = this.dom.slide[this._current];
		this.tl.staggerFromTo(this.dom.anim, 0.25, {autoAlpha: 1, y: 0}, {autoAlpha: 0, y: -20, ease: Power2.easeInOut }, 0.1);
		this.tl.call(() => {
			this.dom.year.innerHTML = slide.getAttribute('data-year');
			this.dom.title.innerHTML = slide.getAttribute('data-title');
			this.dom.description.innerHTML = slide.getAttribute('data-description');
			// Allow spam nav slider
			// this._isBlocked = false;
			// this.updateDraggable(true);
		}, null, null, '+=0');
		this.tl.staggerFromTo(this.dom.anim, 0.25, {autoAlpha: 0, y: 20}, {autoAlpha: 1, y: 0, ease: Power2.easeInOut}, 0.1);
	}

	updateArrow() {

		if (this._current > 0) {
			this.dom.previous.classList.remove('hide');
			if (ENV.template == 'desktop')
				this.dom.previous.querySelector('span').innerHTML = this.dom.slide[this._current - 1].getAttribute('data-year');
		} else {
			this.dom.previous.classList.add('hide');
			// this.dom.previous.querySelector('span').innerHTML = this.dom.slide[this.dom.slide.length - 1].getAttribute('data-year');
		}

		if (this._current < this.dom.slide.length - 1) {
			this.dom.next.classList.remove('hide');
			if (ENV.template == 'desktop')
				this.dom.next.querySelector('span').innerHTML = this.dom.slide[this._current + 1].getAttribute('data-year');
		} else {
			this.dom.next.classList.add('hide');
			// this.dom.next.querySelector('span').innerHTML = this.dom.slide[0].getAttribute('data-year');
		}

	}

	updateDraggable(isDraggable) {
		this._Flkty.options.draggable = isDraggable;
		this._Flkty.updateDraggable();
	}

	/*
	init() {
	}
	bind() {
	}
	unbind() {
	}
	resize(width, height) {
	}
	*/
}



// WEBPACK FOOTER //
// src/js/components/history-slider/history-slider.js